var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { hasValue } from './../utils';
import IndicatorRawScale from './IndicatorRawScale';
import IndicatorSdScale from './IndicatorSdScale';
import IndicatorTrend from './IndicatorTrend';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import ActiveIndicator from '../App/ActiveIndicator';
import IndicatorTooltip from './IndicatorTooltip';
var Summary = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  padding: 0rem 2rem 2rem;\n  transition: opacity 0.4s ease;\n  margin-left: -2rem;\n  margin-right: -2rem;\n  &.active {\n    box-shadow: inset 0px 1px 0 #e0e2e5,\n      inset 0px -1px 0 #e0e2e5;\n    background: #f9fafb;\n    .active-icon {\n      opacity: 1;\n      color: #54a074;\n    }\n    .btn--activate {\n      pointer-events: none;\n    }\n  }\n  .active-icon {\n    position: absolute;\n    top: 2rem;\n    left: 2rem;\n    opacity: 0.2;\n    font-size: 1.6rem;\n  }\n"])));
var SummaryTitle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 2rem 0rem 2rem 2rem;\n  & > * + * {\n    margin-left: 0.8rem;\n    position: relative;\n    z-index: 2;\n  }\n  h3 {\n    pointer-events: none;\n    margin-bottom: 0;\n  }\n  .btn {\n    border: 0;\n    position: absolute;\n    width: calc(100%);\n    font-size: 20px;\n    line-height: 1;\n    top: 0;\n    bottom: 0;\n    padding-left: 2rem;\n    left: 0rem;\n    right: 0rem;\n    z-index: 1;\n    border-radius: 0;\n    // background-image: linear-gradient(\n    //   rgba(0, 0, 0, 0.05),\n    //   transparent 50px\n    // );\n    background-position: 0 -50px;\n    background-repeat: no-repeat;\n    transition: background-position 0.2s ease;\n    &:hover,\n    &:focus {\n      background-color: rgba(0, 0, 0, 0.02);\n      background-position: 0 0px;\n      box-shadow: none;\n    }\n  }\n"])));
var SummaryBody = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 0rem 0rem 0rem 3rem;\n  p.gotham12 {\n    max-width: 240px;\n  }\n"])));

var IndicatorSummary = function IndicatorSummary(_ref) {
  var indicator = _ref.indicator,
      data = _ref.data,
      trends = _ref.trends,
      active = _ref.active,
      activeLayerIndex = _ref.activeLayerIndex,
      region = _ref.region,
      onActivate = _ref.onActivate;
  var rawMetric = {
    min: indicator.raw.min[activeLayerIndex],
    max: indicator.raw.max[activeLayerIndex],
    mean: indicator.raw.mean[activeLayerIndex],
    decimals: indicator.raw.decimals,
    highisgood: indicator.raw.highisgood,
    currency: indicator.raw.currency,
    percent: indicator.raw.percent,
    id: indicator.raw.id
  };
  var rawName = indicator.raw.id;
  var rawValue = data[rawName];
  var sdValue = data[indicator.id]; // is trend line available

  var hasTrend = trends[0][String(rawName).replace('_19', '')]; // if raw and SD values are not available, return early

  if (!hasValue(sdValue) && !hasValue(rawValue)) return null;
  return /*#__PURE__*/React.createElement(Summary, {
    className: clsx({
      active: active
    })
  }, /*#__PURE__*/React.createElement(SummaryTitle, null, /*#__PURE__*/React.createElement(Button, {
    className: "btn--activate knockout12 py-0",
    color: "none",
    onClick: function onClick(e) {
      return onActivate && onActivate(indicator, e);
    }
  }, /*#__PURE__*/React.createElement(ActiveIndicator, {
    className: "active-icon",
    "aria-label": 'activate ' + i18n.translate(indicator.id)
  })), /*#__PURE__*/React.createElement("h3", {
    className: "indicator-name gotham14 w500"
  }, i18n.translate(indicator.id)), /*#__PURE__*/React.createElement(IndicatorTooltip, {
    size: 16,
    indicator: indicator
  })), /*#__PURE__*/React.createElement(SummaryBody, null, /*#__PURE__*/React.createElement(IndicatorRawScale, {
    className: "mb-4",
    indicator: rawMetric,
    value: rawValue,
    region: region
  }), /*#__PURE__*/React.createElement(IndicatorSdScale, {
    className: "my-4",
    indicator: indicator,
    value: sdValue,
    region: region
  }), hasTrend && /*#__PURE__*/React.createElement(IndicatorTrend, {
    className: "mt-4",
    data: trends,
    config: indicator.trend
  })));
};

export default IndicatorSummary;